import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/auth';
import { DashboardLayout } from './components/layout';
import { LoginPage, ForgotPasswordPage, ResetPasswordPage } from './pages/auth';
import { DashboardPage } from './pages/dashboard';
import { ProductListPage, ProductCreatePage, ProductEditPage, ProductDetailPage, FeaturedProductsPage } from './pages/products';
import CategoryListPage from './pages/categories/CategoryListPage';
import CategoryFormPage from './pages/categories/CategoryFormPage';
import { OrderListPage, OrderDetailPage } from './pages/orders';
import { CustomerListPage, CustomerDetailPage } from './pages/customers';
import { ReviewListPage } from './pages/reviews';
import { SettingsPage, AdminUsersPage, IntegrationsPage } from './pages/settings';
import { AnalyticsPage } from './pages/analytics';
import { ContentPagesPage, ContentPageEditor } from './pages/content';
import { FAQListPage, FAQEditorPage } from './pages/faq';
import { HeroCarouselPage } from './pages/carousel';
import { PageBackgroundsPage } from './pages/backgrounds';
import { MediaLibraryPage } from './pages/media';
import { AccessibilityDashboard } from './pages/accessibility';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />

          {/* Protected routes with dashboard layout */}
          <Route
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/dashboard" element={<DashboardPage />} />

            {/* Products */}
            <Route path="/products" element={<ProductListPage />} />
            <Route path="/products/featured" element={<FeaturedProductsPage />} />
            <Route path="/products/new" element={<ProductCreatePage />} />
            <Route path="/products/:id" element={<ProductDetailPage />} />
            <Route path="/products/:id/edit" element={<ProductEditPage />} />

            {/* Categories */}
            <Route path="/categories" element={<CategoryListPage />} />
            <Route path="/categories/new" element={<CategoryFormPage />} />
            <Route path="/categories/edit/:id" element={<CategoryFormPage />} />

            {/* Orders */}
            <Route path="/orders" element={<OrderListPage />} />
            <Route path="/orders/:id" element={<OrderDetailPage />} />

            {/* Customers */}
            <Route path="/customers" element={<CustomerListPage />} />
            <Route path="/customers/:id" element={<CustomerDetailPage />} />

            {/* Reviews */}
            <Route path="/reviews" element={<ReviewListPage />} />

            {/* Content */}
            <Route path="/content" element={<Navigate to="/content/pages" replace />} />
            <Route path="/content/pages" element={<ContentPagesPage />} />
            <Route path="/content/pages/:id/edit" element={<ContentPageEditor />} />
            <Route path="/content/media" element={<MediaLibraryPage />} />

            {/* Hero Carousel */}
            <Route path="/carousel" element={<HeroCarouselPage />} />

            {/* Page Backgrounds */}
            <Route path="/backgrounds" element={<PageBackgroundsPage />} />

            {/* FAQ */}
            <Route path="/faq" element={<FAQListPage />} />
            <Route path="/faq/new" element={<FAQEditorPage />} />
            <Route path="/faq/:id/edit" element={<FAQEditorPage />} />

            {/* Analytics */}
            <Route path="/analytics" element={<AnalyticsPage />} />

            {/* Accessibility */}
            <Route path="/accessibility" element={<AccessibilityDashboard />} />

            {/* Settings */}
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/settings/integrations" element={<IntegrationsPage />} />
            <Route path="/settings/users" element={<AdminUsersPage />} />
          </Route>

          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />

          {/* 404 - Redirect to dashboard */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </AuthProvider>
  );
}

export default App;
